import _ from 'lodash';
import React from 'react';

import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useParams } from 'react-router';

import { notification } from 'antd';
import correctSound from 'assets/audioGame/tingting.mp3';
import wrongSound from 'assets/audioGame/soundfalse.mp3';

import QuestionTypes from 'modules/OlympicSGKModule/components';
import FireWork from 'components/Firework';
import PropTypes from 'prop-types';
import { submit } from '../actions';

Examination.propTypes = {
  studentUnitExercise: PropTypes.bool.isRequired,
};

export default function Examination({ studentUnitExercise }) {
  // Hooks
  const history = useHistory();
  const { index } = useParams();
  const currentIndex = parseInt(index);

  const ref = React.useRef();
  // Redux
  const dispatch = useDispatch();
  const submittedQuestions = useSelector((state) => state.olympicReducer.submittedQuestions);
  const examination = useSelector((state) => state.olympicReducer.examination);

  // Variables
  const count = examination?.questions.length;
  const questions = examination?.questions;

  // Functions
  const next = () => {
    if (currentIndex < count) {
      history.push(`/lms/${studentUnitExercise ? 'exercise' : 'olympic'}/examination/${examination.code}/start/${currentIndex + 1}`);
    } else {
      history.push(`/lms/${studentUnitExercise ? 'exercise' : 'olympic'}/examination/${examination.code}/result`);
    }
  };

  const getFireworksStart = (result) => {
    const audio = new Audio();
    if (result) {
      audio.src = correctSound;
      audio.play();
    } else {
      audio.src = wrongSound;
      setTimeout(() => {
        audio.play();
      }, 500);
    }
    return result ? ref.current.handlerClickStart() : '';
  };

  // Render
  return (
    <div>
      {examination &&
        questions.map((question, i) => {
          if (i + 1 !== currentIndex) return null;
          const QuestionComponent = QuestionTypes[question.type];
          const submittedQuestion = _.find(submittedQuestions, (x) => {
            return x.question.id === question.id;
          });

          return (
            <div key={question.id}>
              <QuestionComponent
                data={question}
                userData={submittedQuestion?.userData}
                questionIndex={i + 1}
                onSubmit={async (userData) => {
                  dispatch(submit({ question, userData }));
                  getFireworksStart(userData.result);
                  setTimeout(() => {
                    notification.open({
                      type: userData.result ? 'success' : 'error',
                      duration: 0.75,
                      placement: 'bottomRight',
                      message: 'Olympic English',
                      description: userData.result ? 'Kết quả: Đúng' : 'Kết quả: Sai',
                      onClose: next,
                    });
                  }, 500);
                }}
              />
            </div>
          );
        })}
      <FireWork ref={ref} />
    </div>
  );
}
